var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.52 116.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f8fd;}.cls-2,.cls-3{fill:#e1146e;}.cls-2{opacity:0.3;}.cls-4{fill:#d11f53;}.cls-5{fill:#fef4f5;}.cls-6{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Payment-Faild") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.63,415.84H243.43a11.7,11.7,0,0,1-11.7-11.7v7.8a11.7,11.7,0,0,0,11.7,11.7h140.2a11.7,11.7,0,0,0,11.7-11.7v-7.8A11.7,11.7,0,0,1,383.63,415.84Z",
    transform: "translate(-229.62 -314.53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.62,9.91h140.2a11.71,11.71,0,0,1,11.71,11.71v83.59a11.7,11.7,0,0,1-11.7,11.7H21.62a11.7,11.7,0,0,1-11.7-11.7V21.62A11.7,11.7,0,0,1,21.62,9.91Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.11,
    y: 2.11,
    width: 163.61,
    height: 107,
    rx: 11.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M383.63,425.76H243.43a13.83,13.83,0,0,1-13.81-13.82V328.35a13.83,13.83,0,0,1,13.81-13.82h140.2a13.84,13.84,0,0,1,13.82,13.82v83.59A13.84,13.84,0,0,1,383.63,425.76Zm-140.2-107a9.6,9.6,0,0,0-9.59,9.59v83.59a9.6,9.6,0,0,0,9.59,9.59h140.2a9.6,9.6,0,0,0,9.59-9.59V328.35a9.6,9.6,0,0,0-9.59-9.59Z",
    transform: "translate(-229.62 -314.53)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.38,357.19H231.73a2.11,2.11,0,1,1,0-4.22H393.38a2.11,2.11,0,1,1,0,4.22Z",
    transform: "translate(-229.62 -314.53)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M273.46,387H251.52a2.11,2.11,0,0,1,0-4.22h21.94a2.11,2.11,0,1,1,0,4.22Z",
    transform: "translate(-229.62 -314.53)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M305.81,387H283.87a2.11,2.11,0,1,1,0-4.22h21.94a2.11,2.11,0,0,1,0,4.22Z",
    transform: "translate(-229.62 -314.53)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M338.15,387H316.21a2.11,2.11,0,0,1,0-4.22h21.94a2.11,2.11,0,0,1,0,4.22Z",
    transform: "translate(-229.62 -314.53)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M370.49,387H348.55a2.11,2.11,0,0,1,0-4.22h21.94a2.11,2.11,0,1,1,0,4.22Z",
    transform: "translate(-229.62 -314.53)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.8,369.81c-1.36-2.43-3.23-3.77-5.28-3.77s-3.91,1.34-5.27,3.77l-22.82,40.77c-1.35,2.42-1.51,4.74-.46,6.55s3.19,2.82,6,2.82h45.13c2.79,0,4.92-1,6-2.82s.9-4.13-.45-6.55Z",
    transform: "translate(-229.62 -314.53)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.52,407.2a3,3,0,1,0,3,3A3,3,0,0,0,359.52,407.2Z",
    transform: "translate(-229.62 -314.53)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.52,403.69c1.11,0,2.09-1.35,2.19-3l1.15-19.56a2.81,2.81,0,0,0-2.83-3h-1a2.81,2.81,0,0,0-2.83,3l1.15,19.56C357.44,402.34,358.42,403.69,359.52,403.69Z",
    transform: "translate(-229.62 -314.53)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/PaymentFailed.711644e7c4bb4e3b02030110b9b63ae8.svg";
export { ForwardRef as ReactComponent };